import React from 'react'

import { useConnect } from 'redux-bundler-hook'

import { selectDashboardContext } from '~/src/Facility/bundle/dashboard'
import FacilityDashboard from '~/src/Facility/Dashboard'
import FacilityDashboardContext from '~/src/Facility/Dashboard/Context'
import { useBreakpoint } from '~/src/Lib/Utils'

export const FacilityDashboardRoute = props => (
  <FacilityDashboardContext.Provider value={selectDashboardContext(props)}>
    <FacilityDashboard />
  </FacilityDashboardContext.Provider>
)

const Connected = props => {
  const { doRoomSetCurrent, ...connectedProps } = useConnect(
    'selectAllDataTypes',
    'selectCurrentFacility',
    'selectFacilitiesRoot',
    'selectMe',
    'selectCurrentHarvestList',
    'selectFacilityCultivars',
    'selectPhases',
    'selectRooms',
    'selectZones',
    'doUpdateUrl'
  )
  const breakpoint = useBreakpoint()

  return <FacilityDashboardRoute {...connectedProps} {...props} breakpoint={breakpoint} />
}

const Memoized = React.memo(Connected)

Memoized.displayName = 'FacilityDashboardRoute'

export default Memoized
